import { FolderTreeNodeStats } from "@bimdata/definitions/dto";

export default (tree: FolderTreeNodeStats[]): {
  classification: FolderTreeNodeStats[],
  // classificationMap: Map<number, FolderTreeNodeStats>
} => {
  
  const classification: FolderTreeNodeStats[] = tree;
  // const classificationMap: Map<number, FolderTreeNodeStats> = new Map();

  const traverseNode = (n: FolderTreeNodeStats) => {
    if (!n.stats) {
      n.stats = [];
    }
    // classificationMap.set(n.id, n);
    n.childNodes.forEach(
      (ch) => {
        traverseNode(ch);
        if (ch.stats) {
          ch.stats.forEach((stat) => {
            const s = n.stats.find(({ model }) => model === stat.model);
            if (s) {
              s.elements += stat.elements;
              s.geometries += stat.geometries;
            } else {
              n.stats.push({ ...stat });
            }
          });
        }
      }
    );
  }

  tree.forEach(traverseNode);
  return { classification, /* classificationMap */ };
};